export const buildOrderObject = order => {
    const { totalPayment, totalDiscount, totalTip } = order.payments.reduce((sums, p) => {
        sums.totalPayment += (p.amount || 0);
        sums.totalDiscount += (p.discount || 0);
        sums.totalTip += (p.tip || 0);
        return sums;
    }, { totalPayment: 0, totalDiscount: 0, totalTip: 0 });

    return {
        ...order,
        totalPayment,
        totalDiscount,
        totalTip,
    };
};